import AddIcon from "@material-ui/icons/Add";
import Typography from "@material-ui/core/Typography";
import React, { useState } from "react";

import CreateAdvertiserModal from "../../../../../components/Advertisers/CreateAdvertiserModal";
import classes from "./AddAdvertiserOption.module.scss";
import { keyDownA11y } from "../../../../../helpers/accessibility";

const AddAdvertiserOption = () => {
  const [isCreateAdvertiserModalOpen, setIsCreateAdvertiserModalOpen] = useState(false);

  const handleOpenCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(true);
  };

  const handleCloseCreateAdvertiserModal = () => {
    setIsCreateAdvertiserModalOpen(false);
  };

  return (
    <>
      <div
        className={classes.container}
        onClick={handleOpenCreateAdvertiserModal}
        onKeyDown={keyDownA11y(handleOpenCreateAdvertiserModal)}
        role="button"
        tabIndex={0}
      >
        <Typography>
          Create New <AddIcon />
        </Typography>
      </div>
      <CreateAdvertiserModal isOpen={isCreateAdvertiserModalOpen} handleClose={handleCloseCreateAdvertiserModal} />
    </>
  );
};

export default AddAdvertiserOption;
